// Messages de validation communs à tous les domaines (API et formulaires du BO), sans dépendance :
// un module de domaine (logistique, adresse…) les importe, jamais l'inverse.

/** Texte trop long : même message partout. */
export const maxLengthMessage = (max: number): string => `${max} caractères au plus.`

/**
 * Nom d'une entité vide (ou seulement des espaces) : même message à l'API et dans le formulaire
 * (transporteurs).
 */
export const NAME_REQUIRED_MESSAGE = 'Le nom est requis.'

/**
 * Adresse email refusée (format) : même message à l'API et dans les formulaires (transporteurs,
 * collaborateurs).
 */
export const INVALID_EMAIL_MESSAGE = 'Adresse email invalide.'
